import { FlightSearch } from '@hub-common/flight-search/flight-search';
import { createReducer, on } from '@ngrx/store';
import * as FiltersActions from './filters.actions';

export const featureKey = 'filters';

export enum FilterProperty {
  viewFilter = 'viewFilter',
  groupByAirline = 'groupByAirline',
  groupByCategory = 'groupByCategory',
  filteredAirlineIds = 'filteredAirlineIds',
  filteredCategoryIds = 'filteredCategoryIds',
  filteredCabinIds = 'filteredCabinIds',
  filteredCabinCodes = 'filteredCabinCodes',
  filteredBrandIds = 'filteredBrandIds',
  filteredUpaIds = 'filteredUpaIds',
  filteredSubfleetIds = 'filteredSubfleetIds',
  filteredUpaSourceId = 'filteredUpaSourceId',
  flightSearch = 'flightSearch',
  viewId = 'viewId',
}

export interface HubFiltersState {
  viewFilter: string;
  groupByAirline: boolean | null;
  groupByCategory: boolean;
  filteredAirlineIds: number[];
  filteredCategoryIds: string[];
  filteredCabinIds: number[];
  filteredCabinCodes: string[];
  filteredBrandIds: number[];
  filteredUpaIds: number[];
  filteredSubfleetIds: number[];
  filteredUpaSourceId: string | null;
  flightSearch: FlightSearch;
  viewId: string | number;
}

// value for the polymorphic setFilterProp setter: one of the filter field value types.
// No discriminant ties value to `name`, so callers can (structurally) pair any name with any
// filter value; `| null` covers the fields that get cleared to null (e.g. filteredUpaSourceId).
export type FilterValue = HubFiltersState[keyof HubFiltersState] | null;

export const initialState: HubFiltersState = {
  viewFilter: 'default',
  groupByAirline: null,
  groupByCategory: true,
  filteredAirlineIds: [],
  filteredCategoryIds: [],
  filteredCabinIds: [],
  filteredCabinCodes: [],
  filteredBrandIds: [],
  filteredUpaIds: [],
  filteredSubfleetIds: [],
  filteredUpaSourceId: null,
  flightSearch: {},
  viewId: '',
};

export const reducer = createReducer(
  initialState,

  on(FiltersActions.setFilterProp, (state, action) => ({
    ...state,
    [action.name]: action.value,
  })),

  on(FiltersActions.resetFilters, state => {
    return {
      ...state,
      ...initialState,
      viewFilter: state.viewFilter === 'flight' ? 'flight' : 'default',
      flightSearch: state.viewFilter === 'flight' ? state.flightSearch : {}
    }
  }),

);
